import React from 'react';
import PropTypes from 'prop-types';
import 'library/styles/components/drop-down-filter.scss';

export default class DropDownFilter extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  render() {
    const  {
      children,
      search,
      pointer=''
    } = this.props;

    return (
      <div>
        <div className={['drop-down-pointer ', pointer].filter(c=>c).join(' ')} />
        <div className='drop-down-filter'>
          <div className='drop-down-filter-search'>
            <label> Filter By: </label>
            { search
              ?
              <input type="text" />
              :
              null
            }
          </div>
          {children}
        </div>
      </div>
    );
  }
}
DropDownFilter.propTypes = {
  sections: PropTypes.object,
  children: PropTypes.array,
  search: PropTypes.bool,
  pointer: PropTypes.string
};
